var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Va-Icon")]),
      _c("h3", [_vm._v("Colors")]),
      _c("v-divider", { staticClass: "mb-4" }),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between my-4" },
        [
          _c("va-icon", { attrs: { icon: "vi vi-chart-pie" } }),
          _c("va-icon", { attrs: { icon: "vi vi-speedometer-1" } }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info" } }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info", color: "primary" } }),
          _c("va-icon", {
            attrs: { icon: "vi vi-c-info", color: "secondary" }
          }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info", color: "success" } }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info", color: "warning" } }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info", color: "error" } }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info", square: "" } }),
          _c("va-icon", {
            attrs: { icon: "vi vi-c-info", square: "", color: "primary" }
          }),
          _c("va-icon", {
            attrs: { icon: "vi vi-c-info", square: "", color: "secondary" }
          }),
          _c("va-icon", {
            attrs: { icon: "vi vi-c-info", square: "", color: "success" }
          }),
          _c("va-icon", {
            attrs: { icon: "vi vi-c-info", square: "", color: "warning" }
          }),
          _c("va-icon", {
            attrs: { icon: "vi vi-c-info", square: "", color: "error" }
          })
        ],
        1
      ),
      _c("h3", [_vm._v("Size")]),
      _c("v-divider", { staticClass: "mb-4" }),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between my-4" },
        [
          _c("va-icon", { attrs: { icon: "vi vi-c-info" } }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info", size: "xs" } }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info", size: "s" } }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info", size: "m" } }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info", size: "l" } }),
          _c("va-icon", { attrs: { icon: "vi vi-c-info", square: "" } }),
          _c("va-icon", {
            attrs: { icon: "vi vi-c-info", square: "", size: "xs" }
          }),
          _c("va-icon", {
            attrs: { icon: "vi vi-c-info", square: "", size: "s" }
          }),
          _c("va-icon", {
            attrs: { icon: "vi vi-c-info", square: "", size: "m" }
          }),
          _c("va-icon", {
            attrs: { icon: "vi vi-c-info", square: "", size: "l" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }